/* tslint:disable */
/* eslint-disable */
export enum ResidencyStatusEnum {
  NzCitizen = 'NZCitizen',
  PermanentResident = 'PermanentResident'
}
